import { RouteObject } from "react-router-dom";
import { lazy } from "react";

import { indentMenuItems } from "../mainMenuListIems";
import { UserPlus, User, Globe, AlignRight, XSquare, Sliders } from "react-feather";
import { userManagementUtil, AccessDenialForm } from "@siba/utilities";

/**
 * Component imports for Home module
 * **/
//const BlankPageWithOutlet = lazy(() => import('../BlankPageWithOutlet'));
const Layout = lazy(() => import("../../Components/DefaultLayout/Layout"));
const BlankPageWithOutlet = lazy(() => import("../BlankPageWithOutlet"));
const Bank = lazy(() => import("./GlobalSetups/Bank/Bank"));
const Channel = lazy(() => import("./GlobalSetups/Channel/AmlStatus"));
const Company = lazy(() => import("./GlobalSetups/Company/Company"));
const Country = lazy(() => import("./GlobalSetups/Country/Country"));
const Department = lazy(() => import("./GlobalSetups/Department/Department"));
const Branch = lazy(() => import("./GlobalSetups/Branch/Branch"));
const ExceptionLog = lazy(() => import("./Troubleshooting/ExceptionLog/ExceptionLog"));
const Relation = lazy(() => import("./GlobalSetups/Category/Category"));
const Section = lazy(() => import("./GlobalSetups/Section/Section"));
const Domain = lazy(() => import("./AccessManagement/Domain/DomainGrid"));
const Permissions = lazy(() => import("./AccessManagement/Permissions/PermissionsGrid"));
const Roles = lazy(() => import("./AccessManagement/Roles/RolesGrid"));
const DocumentCheckList = lazy(() => import("./GlobalSetups/DocumentCheckList/DocumentCheckList"));

export const settingMenu = indentMenuItems([
    {
        name: "User Management",
        path: "",
        icon: UserPlus,
        items: [
            {
                name: "Users",
                path: "/Home/Settings/user",
                icon: User,
                items: undefined
            }
        ]
    },

    {
        name: "Global Setting",
        path: "",
        icon: Globe,
        items: [
            {
                name: "AMLStatus",
                path: "/Home/Settings/global/AmlStatus",
                items: undefined
            },

            {
                name: "Country",
                path: "/Home/Settings/global/Country",
                items: undefined
            },

            {
                name: "Category",
                path: "/Home/Settings/global/Category",
                items: undefined
            },
            {
                name: "AML Document CheckList",
                path: "/Home/Settings/global/DocumentCheckList",
                items: undefined
            }
        ]
    },

    {
        name: "Access Management",
        path: "",
        icon: UserPlus,
        items: [
            {
                name: "Domain",
                path: "/Home/Settings/access/domain",
                icon: User,
                items: undefined
            },
            {
                name: "permissions",
                path: "/Home/Settings/access/permissions",
                icon: User,
                items: undefined
            },
            {
                name: "Roles",
                path: "/Home/Settings/access/roles",
                icon: User,
                items: undefined
            }
        ]
    },

    {
        name: "Troubleshooting",
        path: "",
        icon: AlignRight,
        items: [
            {
                name: "Error Logs",
                path: "/Home/Settings/exception/logs",
                icon: XSquare,
                items: undefined
            }
        ]
    },
    {
        name: "Subscription Settings",
        path: "/home/settings/Subscriptions",
        items: [
            {
                name: "Organisation",
                path: "/home/settings/subscriptions/organisation",
                items: undefined
            }
        ],
        icon: Sliders
    }
]);

export const generalSettingRouteObject: RouteObject = {
    path: "settings",
    element: <BlankPageWithOutlet />,
    children: [
        {
            path: "global",
            element: ["Admin", "Auth.Admin", "Global", "Global.Settings"].some((permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin") ? (
                <BlankPageWithOutlet />
            ) : (
                <AccessDenialForm />
            ),
            children: [
                {
                    path: "Bank",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Bank"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Bank />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "AMLStatus",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Channel"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Channel />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "Company",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Company"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Company />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "Country",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Country"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Country />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "Department",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Department"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Department />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                // {
                //     path: "InsuranceCompany",
                //     element: ["Admin", "Auth.Admin","Global", "Global.Settings", "Global.Settings.InsuranceCompany"].some((permission) => userManagementUtil.getUserRoleList()?.includes(permission)) || permission == "Admin" ? (
                //         <InsuranceCompany />
                //     ) : (
                //         <AccessDenialForm />
                //     )
                // },
                {
                    path: "Branch",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Branch"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Branch />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                // { path: "ExceptionLog", element: <ExceptionLog /> },
                {
                    path: "Category",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Relation"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Relation />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "DocumentCheckList",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Section"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <DocumentCheckList />
                    ) : (
                        <AccessDenialForm />
                    )
                }
            ]
        },
        {
            path: "access",
            element: <BlankPageWithOutlet />,
            children: [
                {
                    path: "Domain",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Relation"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Domain />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "permissions",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Relation"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Permissions />
                    ) : (
                        <AccessDenialForm />
                    )
                },
                {
                    path: "Roles",
                    element: ["Admin", "Auth.Admin", "Global", "Global.Settings", "Global.Settings.Relation"].some(
                        (permission) => userManagementUtil.getUserRoleList()?.includes(permission) || permission == "Admin"
                    ) ? (
                        <Roles />
                    ) : (
                        <AccessDenialForm />
                    )
                }
            ]
        },
        {
            path: "exception",
            element: <BlankPageWithOutlet />,
            children: [{ path: "logs", element: <ExceptionLog /> }]
        },
        { path: "subscriptions", element: <BlankPageWithOutlet />, children: [{ path: "organisation", element: <Company /> }] }
    ]
};
